import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Funciones } from 'app/models/funciones.model';
import { LOCAL_STORAGE } from '../../constants/localstorage.constant';

import { ENDPOINT } from 'app/constants/endpoints.constant';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  public href = '';
  funciones: Funciones[] = [];
  loggedInUserInfo: {};
  constructor(private http: HttpClient, private router: Router) { }

  public validate(login): Observable<any> {
    return this.http.post<any>(`${ENDPOINT.msLogin.api}${ENDPOINT.msLogin.login}/login/`, login);
  }

  logout(userId): Observable<any> {
    return this.http.post<any>(`${ENDPOINT.msLogin.api}${ENDPOINT.msLogin.login}/logout`, userId);
  }

  getToken(): any {
    return localStorage.getItem(LOCAL_STORAGE.KEYS.TOKEN_VALID);
  }

  isValidToken(): any {
    const tokenValid = localStorage.getItem(LOCAL_STORAGE.KEYS.TOKEN_VALID);
    this.href = this.router.url;
    if (this.href == '/pages/auth/login-2' && tokenValid == 'true') {
      this.router.navigateByUrl('/administracion/usuarios');
      return true;
    } else if (this.href !== '/pages/auth/login-2' && tokenValid == 'false') {
      this.router.navigateByUrl('/pages/auth/login-2');
      return false;
    }
  }

  validarReportes(): any {
    if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_EMPRESA) === '') {
      this.router.navigate(['/empresas']);
    } else if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_USUARIO) !== '') {


    } else {
      this.router.navigate(['/pages/auth/login-2']);
    }

  }

  validarDocumentos(): any {
    if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_EMPRESA) === '') {
      this.router.navigate(['/empresas']);
    } else if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_USUARIO) !== '') {

    } else {
      this.router.navigate(['/pages/auth/login-2']);
    }
  }

  async validarIdEmpresa(params?: Funciones[]): Promise<any> {
    if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_USUARIO) !== '') {
      await this.validarIdUsuario(params);
    } else {
      this.router.navigate(['/pages/auth/login-2']);
    }
  }

  async validarIdUsuario(params?: Funciones[]): Promise<any> {
    if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_EMPRESA) === '') {
      this.router.navigate(['/empresas']);
    } else if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_USUARIO) !== '') {
      if (params) {
        params.forEach((array: Funciones) => {
          array['funcion'];
        });
      }
    } else {
      this.router.navigate(['/pages/auth/login-2']);
    }
  }

  validarIdEmpresaIdUsuario(): any {
    if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_EMPRESA) === '') {
      this.router.navigate(['/empresas']);
    } else if (localStorage.getItem(LOCAL_STORAGE.KEYS.ID_USUARIO) !== '') {
    } else {
      this.router.navigate(['/pages/auth/login-2']);
    }
  }

}
